<template>
  <div>
    <WtTitle h2="h2">
      <span class="pr-2">Your Program Overview</span>
      <BTooltip
        class="b-tooltip-custom"
        label="Updates daily."
        position="is-right"
        animated="animated"
        type="is-light"
        multilined="multilined"
      >
        <BIcon icon="help-circle-outline" />
      </BTooltip>
    </WtTitle>
    <ProgramHealth :program="$auth.user().program" />
  </div>
</template>

<script>
import WtTitle from "@@/WtTitle/WtTitle.vue";
import analyticsTrackingMixin from "@/mixins/analyticsTrackingMixin";
import ProgramHealth from "@@/Program/ProgramHealth.vue";

export default {
  name: "AdminProgramOverview",
  components: {
    WtTitle,
    ProgramHealth
  },
  mixins: [analyticsTrackingMixin],
  mounted() {
    this.trackFeatureView("admin", "program_stats");
  }
};
</script>
